import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import styles from "./SettingFileInput.module.css";

const SettingFileInput = (props) => {
  const uploadFile = (event, type) => {
    let file = event.target.files[0];
    let fileSize = file.size;
    let sizeMb = (fileSize / (1024 * 1024)).toFixed(3);
    let image = URL.createObjectURL(file);
    let new_id = new Date() + type;
    let data = {
      id: new_id,
      name: file.name,
      displayName: file.name,
      size: sizeMb,
      image: image,
      upload: false,
    };
    props.uploadFile(file, data);
  };

  return (
    <Box style={{ width: "100%" }}>
      <Box
        className={styles.mainView}
        style={{
          border: props?.border ? props.border : "0px",
        }}
      >
        <input
          id={props.id}
          multiple={false}
          type="file"
          className={styles.inputFile}
          onChange={(e) => {
            e.stopPropagation();
            uploadFile(e, props.type);
          }}
        />
        <label htmlFor={props.id} className={styles.label}>
          <Box px={2} className={styles.uploadView}>
            <Typography
              className={styles.uploadText}
              style={{
                color: props?.value ? "#000000" : "#AAA",
              }}
            >
              {props?.value ? props.value : "Upload File"}
            </Typography>
          </Box>
        </label>
        {props?.value ? (
          <Typography
            className={styles.close}
            onClick={(e) => {
              e.stopPropagation();
              props.onRemove();
            }}
          >
            x
          </Typography>
        ) : null}
      </Box>
      <Box>
        {props?.error ? (
          <Typography className={styles.errorText}>{props.error}</Typography>
        ) : null}
      </Box>
    </Box>
  );
};

export default SettingFileInput;
